import { axiosPost } from '@/utils/httpUtil'
import { API_URL } from '@/utils/constant/app.constants'

/**
 * @description: httpAuthLogin (딜러버리 인증 관리 - 로그인)
 * @param {string} userId 사용자ID
 * @param {string} passwd 비밀번호
 * @param {string} dvcId "string"
 * @param {string} dvcModelNm "web"
 * @param {string} dvcFltfNm "android"
 * @param {string} dvcFltfNmVer "0"
 * @param {string} appPkgVer "1.0.0"
 * @param {string} appId "com.gsr.mgssm.dev"
 * @param {string} joinCd 가입코드
 */
export const httpAuthLogin = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/dlvy-login',
    data: pdata
  })
}

export const httpAuthAppstoreLogin = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/appstore-login',
    data: pdata
  })
}
/**
 * @description: httpAuthRequestChkVal (수퍼 인증 관리 - 확인문자 발송을 위한 필요 정보를 조회)
 *
 **/
export const httpAuthPrepareChkVal = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/prepare-chk-val',
    data: pdata
  })
}

/**
 * @description: httpAuthRequestChkVal (수퍼 인증 관리 - 확인문자 발송요청)
 *
 **/
export const httpAuthRequestChkVal = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/request-chk-val',
    data: pdata
  })
}

/**
 * @description: httpAuthCheckChkVal (수퍼 인증 관리 - 로그인 확인문자 검증)
 *
 **/
export const httpAuthCheckChkVal = (pdata) => {
  return axiosPost({
    url: API_URL + '/comm/api/auth/check-chk-val',
    data: pdata
  })
}
